export default function SvgDot() {
  return (
    <svg
      width="11"
      height="11"
      viewBox="0 0 9 9"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="4.5" cy="4.5" r="4" fill="white"/>
    </svg>
  );
}
